import styles from "./style.module.css";

function FullPageLoading() {
  let darkTheme = false;
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    darkTheme = true;
  } else {
    darkTheme = false;
  }
  const waveColor = darkTheme ? "wave-dark" : "wave-light";
  return (
    <div className={styles["center"]} style={{ backgroundColor: darkTheme ? "#1a2035" : "white" }}>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
      <div className={`${styles["wave"]} ${styles[waveColor]}`}></div>
    </div>
  );
}

export default FullPageLoading;
